<template>
  <vf-button
    v-if="!isComingSoon && $feature.showFindInStoreOnPDP"
    class="p-0"
    size="tiny"
    variant="text-link"
    @click="handleFindInStore()"
  >
    <span class="center text-xs underlined i-flex">
      {{ $t.findInStore }}
    </span>
  </vf-button>
</template>

<script lang="ts" setup>
const { $feature } = useNuxtApp()
const {
  attributeSelectionLabels,
  findInStore,
  handleNextAttribute,
  isComingSoon
} = usePdp()

const handleFindInStore = async () => {
  try {
    handleNextAttribute({ enableFindInStore: true }, () => findInStore(attributeSelectionLabels.value))
  }
  catch (e) {
    console.info(e)
  }
}
</script>
